import React from 'react'
import PropTypes from 'prop-types'
import { SpinLoader } from 'src/components'
import { mergeProps } from 'src/util'
import styles from './LoadingView.scss'

const LoadingView = ({ isLoading, error, ...domProps }) => (
  <div {...mergeProps()({ className: styles.container }, { className: domProps.className })}>
    {isLoading && <SpinLoader />}
    {!!error && <div>{error}</div>}
  </div>
)

LoadingView.propTypes = {
  isLoading: PropTypes.bool,
  error: PropTypes.node,
}

export default LoadingView
